import { render } from "./SelectSize.vue?vue&type=template&id=088fa539"
import script from "./SelectSize.vue?vue&type=script&lang=js"
export * from "./SelectSize.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SelectSize.vue?vue&type=style&index=0&id=088fa539&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__